module.exports = __webpack_public_path__ + "img/国家遥感中心无人机遥感比测.7060571d.jpg";